<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    src?: string
    alt?: string
    /** TwicPics ratio. "none" lets the image fill a container that is sized by its parent. */
    ratio?: string
  }>(),
  {
    ratio: 'none',
  },
)

/**
 * Locally the backend hands out a pre-signed bucket URL because TwicPics cannot
 * reach the dev MinIO. Letting TwicPics prefix its CDN domain would break it.
 */
const isDirectUrl = computed(() => /^https?:\/\//.test(props.src ?? ''))
</script>

<template>
  <img v-if="isDirectUrl" :src="src" :alt="alt" />
  <TwicImg v-else :src="src" :alt="alt" :ratio="ratio" mode="cover" />
</template>
